import React, { FormEvent } from 'react';

interface IProps {
  children: React.ReactNode;
  onSubmit?: () => void;
  className?: string;
}

const AdvancedForm = ({ children, onSubmit, className }: IProps) => {
  const formSubmit = (e: FormEvent) => {
    e.preventDefault();

    if (onSubmit) {
      return onSubmit();
    }
  };

  return (
    <div className={`advanced-form ${className || ''}`}>
      <form onSubmit={formSubmit}>{children}</form>
    </div>
  );
};

export default AdvancedForm;
